import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: undefined,
  error: undefined,
};

export const GetSubscriptionDetailSlice = createSlice({
  name: "getSubscriptionDetail",
  initialState,
  reducers: {
    getSubscriptionDetailRequest(state) {
      state.loading = true;
    },
    getSubscriptionDetailRequestSuccess(state, action) {
      state.loading = false;
      state.response = action.payload;
      state.error = undefined;
    },
    getSubscriptionDetailRequestError(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.response = undefined;
    },
  },
});

export const {
  getSubscriptionDetailRequest,
  getSubscriptionDetailRequestSuccess,
  getSubscriptionDetailRequestError,
} = GetSubscriptionDetailSlice.actions;

export default GetSubscriptionDetailSlice.reducer;
